import { Actions, Entities } from '@space-lib/datahub'
import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import type { RoleType } from '@space-shell/core/store'

type RoleTypeDataHubActions = {
  [key in RoleType]:
    | Actions.CLICK_CREATOR_VIEW_AS_ROLE_OPTIONS
    | Actions.CLICK_MEMBER_VIEW_AS_ROLE_OPTIONS
    | Actions.CLICK_USER_WITHOUT_ACCESS_VIEW_AS_ROLE_OPTIONS
    | Actions.CLICK_LOGGED_OUT_USER_VIEW_AS_ROLE_OPTIONS
}

const ROLE_DATA_HUB_ACTIONS: RoleTypeDataHubActions = {
  Creator: Actions.CLICK_CREATOR_VIEW_AS_ROLE_OPTIONS,
  Member: Actions.CLICK_MEMBER_VIEW_AS_ROLE_OPTIONS,
  UserNoAccess: Actions.CLICK_USER_WITHOUT_ACCESS_VIEW_AS_ROLE_OPTIONS,
  UserLogout: Actions.CLICK_LOGGED_OUT_USER_VIEW_AS_ROLE_OPTIONS
}

const useDataHubRoleEvents = () => {
  const { sendDataHubEvent } = useDataHubEvents()

  const sendDataHubEventByRole = (roleType: RoleType) => {
    sendDataHubEvent({
      group: Entities.HEADER_VIEW_AS,
      name: ROLE_DATA_HUB_ACTIONS[roleType]
    })
  }

  return { sendDataHubEventByRole }
}

export default useDataHubRoleEvents
